import React from 'react';
import { PortCall } from '../../../types/ViewModel/PortCall';
import { ChemicalCategory, ChemicalOrderItemRow, Heading3, ChemicalOrderWrapper } from './ChemicalOrder.styles';
import ChemicalCategoryOrderItems from './ChemicalCategoryOrderItems';
import { ChemicalOrderReport } from '../../../types/ViewModel/TankCleaning/Order/ChemicalOrderReport';
import ChemicalOrderTabMenu from './ChemicalOrderHeader';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
    chemicalOrderFormData: ChemicalOrderReport;
    selectedPortCallId: number;
    previousPortCallWithRob?: PortCall;
    imoNumber: number;
    orderIndex: number;
};

const ChemicalOrderComponent: React.FC<Props> = (props) => {
    const chemicalOrderPreviousRobPortName = props.previousPortCallWithRob?.port?.portName
        ? ` - ${props.previousPortCallWithRob?.port?.portName}`
        : '';

    return (
        <ChemicalOrderWrapper>
            <ChemicalOrderTabMenu></ChemicalOrderTabMenu>
            {props.chemicalOrderFormData &&
                props.chemicalOrderFormData.chemicalCategoryOrderReportItems.map((categoryReportItem, index) => {
                    return (
                        <ul className="category-list" key={`category-list-1_${props.orderIndex}_${categoryReportItem.category?.categoryId}_${index}`}>
                            <ChemicalCategory className="order">
                                <Heading3>
                                    <ChemicalOrderItemRow>
                                        <span className={'category-col'}>{categoryReportItem.category?.name}</span>
                                        <span title={'Lastest ROB at ' + chemicalOrderPreviousRobPortName}>
                                            {'Latest ROB'}
                                            <FontAwesomeIcon className="info-icon" icon="info-circle" />
                                        </span>
                                        <span className="current-order">{'Current order'}</span>
                                        <span>{'Comment'}</span>
                                    </ChemicalOrderItemRow>
                                </Heading3>
                                <ChemicalCategoryOrderItems
                                    chemicalOrderItems={categoryReportItem.chemicalOrderReportItems}
                                    previousPortCallWithRob={props.previousPortCallWithRob}
                                ></ChemicalCategoryOrderItems>
                            </ChemicalCategory>
                        </ul>
                    );
                })}
        </ChemicalOrderWrapper>
    );
};

export default ChemicalOrderComponent;
